class NeedHelpButton extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Smooth scroll voor buttons
		this.initSmoothScroll();
		
		// Accessibility verbeteringen
		this.initAccessibility();
		
		// Hover effecten
		this.initHoverEffects();
	}

	initSmoothScroll() {
		const button = this.querySelector('.need-help-button__btn');
		if (button) {
			button.addEventListener('click', (e) => {
				// Voeg smooth scroll toe als de link naar een sectie op dezelfde pagina verwijst
				const href = button.getAttribute('href');
				if (href && href.startsWith('#')) {
					e.preventDefault();
					const target = document.querySelector(href);
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}
				}
			});
		}
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const button = this.querySelector('.need-help-button__btn');
		if (button) {
			button.setAttribute('aria-label', 'Need help button');
		}
	}

	initHoverEffects() {
		// Voeg extra hover effecten toe voor betere UX
		const button = this.querySelector('.need-help-button__btn');
		if (button) {
			button.addEventListener('mouseenter', () => {
				button.style.willChange = 'background-color';
			});
			
			button.addEventListener('mouseleave', () => {
				button.style.willChange = 'auto';
			});
		}
	}
}

// Registreer de custom element
customElements.define('need-help-button', NeedHelpButton);
